import { render, staticRenderFns } from "./ComIn.vue?vue&type=template&id=af6d9640&scoped=true&"
import script from "./ComIn.vue?vue&type=script&lang=js&"
export * from "./ComIn.vue?vue&type=script&lang=js&"
import style0 from "./ComIn.vue?vue&type=style&index=0&id=af6d9640&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af6d9640",
  null
  
)

export default component.exports